<template>
<!-- 个人中心 联系我们 开发票页面 -->
  <div id="get-invoice">
    <!-- title -->
    <div class="top-title">
      <img src="../../assets/img/login-img/3-1档案-返回ic@2x.png" alt="" class="back-icon" @click="goBack">
      <p class="title-text siyuan-bold">开具发票</p>
    </div>
    <!-- end -->
    <div class="content-box">
      <p class="content-text">长按识别二维码，加深读客服微信，获取发票</p>
      <img src="../../assets/img/common-img/erweima.png" alt="" class="content-img">
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goBack () {
      this.$router.back(-1)
    }
  }
}
</script>
<style lang="postcss">
#get-invoice {
  width: 100vw;
  height: 100vh;
  background-color: #fffffd;
  & .top-title {
    width: 100%;
    padding: 27px 0;
    top: 0;
    position: fixed;
    width: 100%;
    z-index: 999;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #fffffd;
    background-color: #fffffd;
    box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
    & .back-icon {
      width: 17px;
      height: 34px;
      position: absolute;
      left: 30px;
    }
    & .title-text {
      font-size: 34px;
      font-family: "SourceHanSansCN Medium";
      font-weight: 400;
    }
  }
  & .content-box {
    position: relative;
    top: 88px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    & .content-text {
      margin-top: 120px;
      font-size: 30px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
    & .content-img {
      margin-top: 44px;
      width: 340px;
      height: 501px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shenduUserInfo/SdGetInvoice.vue